import { clarity } from "@wb/ui/analytics/clarity";
import { state } from "@wb/ui/analytics/state";
import { type FC, useEffect } from "react";
import { z } from "zod";

const schema = z.object({
  id: z.string().length(10, "Invalid Clarity ID"),
});

type Props = z.infer<typeof schema>;

// https://clarity.microsoft.com
export const ClarityAnalytics: FC<Props> = ({ id }) => {
  useEffect(() => {
    state.instances.push(clarity);
  }, []);

  return (
    <script type="text/javascript">
      {`(function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
			})(window, document, "clarity", "script", "${id}");`}
    </script>
  );
};
